export const quizQuestions = [
  {
    id: "question15",
    videoId: "video15",
    topic: "Driving",
    question: "What does a traffic lights warning sign mean?",
    options: [
      "There is a traffic light behind me",
      "There is no traffic light ahead",
      "There will be a traffic light ahead",
    ],
    correctAnswer: "There will be a traffic light ahead",
    descriptionTitle: "Traffic Lights Warning Sign",
    description1:
      "Traffic light warning signs are used to alert drivers to the presence of a traffic signal (usually a traffic light) ahead and to provide advance notice of its operation. These signs serve as a visual cue to drivers, giving them time to slow down, anticipate the upcoming traffic signal, and respond safely and appropriately to the changing traffic conditions. It's important for drivers to be attentive and follow these signs to ensure safe and orderly traffic flow.",
  },
  {
    id: "question16",
    videoId: "video16",
    topic: "Driving",
    question: "A steep grade ascent means that:",
    options: [
      "An incline is up ahead, switch to low gear",
      "An inclie is up ahead, drive faster",
      "Drive faster to overcome the ascent",
    ],
    correctAnswer: "An incline is up ahead, switch to low gear",
    descriptionTitle: "Traffic Lights Warning Sign",
    description1:
      "Traffic light warning signs are used to alert drivers to the presence of a traffic signal (usually a traffic light) ahead and to provide advance notice of its operation. These signs serve as a visual cue to drivers, giving them time to slow down, anticipate the upcoming traffic signal, and respond safely and appropriately to the changing traffic conditions. It's important for drivers to be attentive and follow these signs to ensure safe and orderly traffic flow.",
  },
  {
    id: "question17",
    videoId: "video17",
    topic: "Driving",
    question: "In a roundabout (rotunda), which has road rights?",
    options: [
      "The vehicles approaching the roundabout",
      "The vehicles in the roundabout",
      "The vehicles facing the green light",
    ],
    correctAnswer: "The vehicles in the roundabout",
    descriptionTitle: "Traffic Lights Warning Sign",
    description1:
      "Traffic light warning signs are used to alert drivers to the presence of a traffic signal (usually a traffic light) ahead and to provide advance notice of its operation. These signs serve as a visual cue to drivers, giving them time to slow down, anticipate the upcoming traffic signal, and respond safely and appropriately to the changing traffic conditions. It's important for drivers to be attentive and follow these signs to ensure safe and orderly traffic flow.",
  },
];
